module.exports = __webpack_public_path__ + "img/Network Topology > WIP.94baef9a.png";